// colors will be an object who's keys are the formatted string values of the group/category/state names as they appear in the interface.
export const colors: Record<string, string> = {};
